var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.status)?_c('span',{staticClass:"userStatus disabled"},[_vm._v("禁用")]):_vm._e(),(_vm.status === 1)?_c('span',{staticClass:"userStatus enabled"},[_vm._v("启用")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }